import { useContext } from "react"
import { GlobalContext } from "../../context/GlobalContext"

export const useToast = () => {
  const { toast } = useContext(GlobalContext)
  return toast
}
